<template>
  <div class="home-view internal">
    <section class="-content">
      <div class="container">
        <h1 class="title-default">Situação Financeira</h1>

        <!-- <a href="javascript:void(0)" class="btn-print" @click="print()"><i class="icon -print"></i> Imprimir</a> -->

        <!-- Estático -->
        <div class="iframe" v-if="extrato">
          <article>
            <div class="user-data">
              <div class="-list">
                <div class="wrapper-icon">
                  <span class="icon -building-o"></span>
                </div>
                <ul>
                  <li>
                    <strong class="label">Empreendimento:</strong>
                    <span class="desc">{{ extrato.EMP_ST_NOME }}</span>
                  </li>

                  <li>
                    <strong class="label">Bloco:</strong>
                    <span class="desc">{{ extrato.BLO_ST_NOME }}</span>
                  </li>

                  <li>
                    <strong class="label">Unidade:</strong>
                    <span class="desc">{{ extrato.UND_ST_CODIGO }}</span>
                  </li>

                  <li>
                    <strong class="label">Cliente:</strong>
                    <span class="desc">{{ extrato.AGN_ST_NOME }}</span>
                  </li>
                </ul>
              </div>

              <div class="-list">
                <div class="wrapper-icon">
                  <span class="icon -wallet-o"></span>
                </div>
                <ul>
                  <li>
                    <strong class="label">Valor do Contrato:</strong>
                    <span class="desc">{{ formatCurrency(extrato.CTO_RE_VALORCONTRATO) }}</span>
                  </li>

                  <li>
                    <strong class="label">Contrato:</strong>
                    <span class="desc">{{ extrato.CTO_IN_CODIGO }}</span>
                  </li>

                  <!-- <li>
                    <strong class="label">Valor Original do Contrato:</strong>
                    <span class="desc">155.515,00</span>
                  </li> -->

                  <li>
                    <strong class="label">Data Base:</strong>
                    <span class="desc">{{ formatDate(todayDate) }}</span>
                  </li>
                  <li>
                    <strong class="label">Data Assinatura:</strong>
                    <span class="desc">{{ formatDate(extrato.CTO_DT_ASSINATURA) }}</span>
                  </li>
                </ul>
              </div>

              <div class="-list">
                <div class="wrapper-icon">
                  <span class="icon -key-o"></span>
                </div>
                <ul>
                  <li>
                    <strong class="label">Total a pagar:</strong>
                    <span class="desc">{{ formatCurrency(unpaidVal) }}</span>
                  </li>

                  <li>
                    <strong class="label">Total Pago:</strong>
                    <span class="desc">{{ formatCurrency(paidVal) }}</span>
                  </li>

                  <!-- <li>
                    <strong class="label">Saldo em:</strong>
                    <span class="desc">0</span>
                  </li> -->
                </ul>
              </div>
            </div>
          </article>
        </div>

        <div class="responsive" v-if="extrato.DadosParcela && extrato.DadosParcela.cDadosParcela && extrato.DadosParcela.cDadosParcela.length">
          <table class="table-finances">
            <thead>
              <tr>
                <th @click="toggleModalInfo('TIPO', 'Tipo de Parcela')"><span class="holder">Tipo</span></th>
                <th @click="toggleModalInfo('PARCELA', 'Número da Parcela')"><span class="holder">Parcela</span></th>
                <th><span class="holder">Vencimento</span></th>
                <th @click="toggleModalInfo('VALOR ORIGINAL', 'Valor da parcela original conforme contrato sem correção monetária INCC / IPCA')"><span class="holder">Valor <br>Original</span></th>
                <th @click="toggleModalInfo('VALOR PAGO', 'Valor pago da parcela.')"><span class="holder">Valor<br /> pago</span></th>
                <th @click="toggleModalInfo('CORREÇÃO', 'Refere-se a correção monetária correspondente da parcela INCC / IPCA, conforme cláusula de correção do contrato.')"><span class="holder">Correção</span></th>
                <th><span class="holder">Taxas</span></th>
                <th @click="toggleModalInfo('ENCARGO', 'Multa e juros moratórios devido ao atraso no pagamento')"><span class="holder">Encargo</span></th>
                <th><span class="holder">Desconto</span></th>
                <th @click="toggleModalInfo('DATA DE PAGAMENTO', 'Data de pagamento da parcela.')"><span class="holder">Data de<br />pagamento</span></th>
                <th @click="toggleModalInfo('VALOR DA PARCELA', 'Valor total da parcela.')"><span class="holder">Valor da<br />Parcela</span></th>
                <th>&nbsp;</th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in extrato.DadosParcela.cDadosParcela" :key="i">
                <td>
                  <template v-if="item.PAR_CH_RECEITA && item.PAR_CH_RECEITA.toLowerCase() == 'financiamento'">Financiamento</template>
                  <template v-else-if="item.PAR_CH_RECEITA && item.PAR_CH_RECEITA.toLowerCase() == 'permuta'">Permuta</template>
                  <template v-else>{{ item.PAR_DS_PARCELA }}</template>
                </td>
                <td>{{ item.PAR_ST_SEQUENCIA }}</td>
                <td>{{ formatDate(item.PAR_DT_VENCIMENTO) }}</td>
                <td>{{ formatCurrency(item.PAR_RE_VALORORIGINAL) }}</td>
                <td>{{ isPaid(item) ? formatCurrency(item.PAR_RE_VALORPAGO) : '-' }}</td>
                <td>{{ sumArray([item.PAR_RE_VALORCORRECAOBX, item.PAR_RE_VALORCORRECAO_ATR]) || '-' }}</td>
                <td>{{ formatDots(item.PAR_RE_VALORTAXAS) }}</td>
                <td>{{ formatDots(item.PAR_RE_VALORENCARGOS) }}</td>
                <td>{{ formatDots(item.PAR_RE_VALORDESCONTO) }}</td>
                <td>{{ isPaid(item) ?formatDate(item.PAR_DT_BAIXA) : '-' }}</td>
                <td>{{ formatCurrency(item[isPaid(item) ? 'PAR_RE_VALORPAGO' : 'PAR_RE_VALORATUALIZADO']) }}</td>

                <td v-if="isPaid(item)"></td>

                <td v-else-if="item.extratoBoleto && item.extratoBoleto.tem_boleto === 'Sim'">
                  <button @click="toggleModalBars(item)"><i class="icon -pdf"></i></button>
                  <!-- <button @click="toggleModalBars(item)"><i class="icon -bars-code"></i></button> -->
                </td>

                <td v-else-if="item.PAR_CH_STATUSENVIO === 'P'">
                  <button class="processing">Em processamento...</button>
                  <a v-if="!isReloading" href="javascript:void(0)" class="refresh-button" @click="recarregar(item)">Recarregar</a>
                </td>

                <td v-else-if="['N', 'R', 'E'].includes(item.PAR_CH_STATUSENVIO) && !isExpired(item) && allowAntecipacao && canShowAntecipacao(item)">
                  <button @click="simulaAntecipacao(item)" class="-simulate">Simular <br>antecipação</button>
                </td>

                <td v-else>-</td>

                <td><span class="badge" :class="[isExpired(item) ? '-danger' : isPaid(item) ? '-success' : '-warning']">{{ returnTextParcela(item) }}</span></td>
              </tr>
            </tbody>
          </table> <!-- /table -->

          <p class="warning-month">
            Os valores que constam no extrato são relativos ao mês corrente e os valores dos boletos referem-se ao mês de vencimento.
          </p>
        </div><!-- /responsive -->

        <!-- /Estático -->

        <div v-if="isLoading || isError">
          <h2 class="aligncenter">{{ isError ? 'Erro ao carregar.' : 'Carregando...' }}</h2>
        </div>
      </div> <!-- /.container -->
    </section> <!-- /.-content -->

    <transition name="fade">
      <ModalText :data="optsModalBars" @close="optsModalBars.render = false" v-if="optsModalBars.render" />
    </transition>

    <transition name="fade">
      <ModalText :data="optsModalInfo" @close="optsModalInfo.render = false" v-if="optsModalInfo.render" />
    </transition>

    <transition name="fade">
      <ModalText :data="optsModalAnt" @close="toggleModalAnt()" @antecipar="antecipaParcela" v-if="optsModalAnt.render" />
    </transition>

    <transition name="fade">
      <ModalText :data="optsModalBoleto" @close="optsModalBoleto.render = false" v-if="optsModalBoleto.render" />
    </transition>
  </div>
</template>

<script>
import PagesService from '@/services/Pages'
import ModalText from '@/components/ModalText'
const moment = require('moment')

export default {
  name: 'situacao-financeira',

  components: {
    ModalText
  },

  data () {
    const data = {
      isReloading: false,
      isError: false,
      isLoading: true,
      extrato: {},

      todayDate: new Date(),

      paidVal: 'R$ 0,00',
      toPay: 'R$ 0,00',
      unpaidVal: 'R$ 0,00',

      optsModalBars: {
        type: 'BARCODE',
        show: true,
        render: false
      },

      optsModalAnt: {
        type: 'ANTICIPATION',
        typeStatus: '',
        info: null,
        show: true,
        render: false
      },

      optsModalInfo: {
        type: 'INFO',
        text: '',
        show: true,
        render: false
      },

      optsModalBoleto: {
        type: 'BOLETO_SUCCESS',
        linhaDigitavel: '',
        show: true,
        render: false
      }
    }

    return data
  }, // data()

  beforeMount () {
    this.load()
    this.todayDate.setHours(0, 0, 0, 0)
  }, // beforeMount()

  mounted () {
  }, // mounted()

  methods: {
    async load (first = true) {
      if (first) {
        this.isLoading = true
        this.isError = false
      } else {
        this.isReloading = true
      }

      try {
        let { contratoAtual } = this.$store.state
        let xhr = await PagesService.getExtrato(contratoAtual.codigo)

        this.extrato = xhr

        // Soma valores pagos e não pagos
        if (xhr.DadosParcela && xhr.DadosParcela.cDadosParcela) {
          let isArray = Array.isArray(xhr.DadosParcela.cDadosParcela)

          if (!isArray) {
            this.extrato.DadosParcela.cDadosParcela = [this.extrato.DadosParcela.cDadosParcela]
          }
          // let obj = isArray ? this.extrato.DadosParcela.cDadosParcela : [this.extrato.DadosParcela.cDadosParcela]

          // this.paidVal = this.sumVals(this.extrato.DadosParcela.cDadosParcela, 'PAR_RE_VALORPAGO')
          this.paidVal = this.extrato.DadosParcela.cDadosParcela[0].VLR_PAGO
          // this.unpaidVal = this.sumVals(this.extrato.DadosParcela.cDadosParcela, 'VLR_CORRIGIDO_TOTAL')
          this.unpaidVal = this.extrato.DadosParcela.cDadosParcela[0].VLR_APAGAR
          this.toPay = this.extrato.DadosParcela.cDadosParcela[0].VLR_APAGAR

          for (let parcela of this.extrato.DadosParcela.cDadosParcela) {
            if (parcela.PAR_CH_STATUSENVIO === 'P' && !this.isDatePast(parcela)) {
              // let { contratoAtual } = this.$store.state.contratoAtual
              // let obj = { codigoContrato: contratoAtual.codigo, codigoParcela: item.PAR_IN_CODIGO }
              await PagesService.getBoletoAntecipacao(this.$store.state.contratoAtual.codigo, parcela.PAR_IN_CODIGO)
            }
          }
        }

        this.isLoading = false
        this.isReloading = false
      } catch (e) {
        this.isError = true
        console.error('Falha ao carregar extrato', e)
      }
    }, // load()

    formatDate (data, format = 'DD/MM/YYYY') {
      // DD/MM/YYYY HH:mm:ss
      if (!data) return ''

      return moment(data).format(format)
    }, // formatDate()

    sumPaidVals (arr) {
      let numbers = []
      let number = 0

      arr = arr.map(item => {
        let { PAR_RE_VALORPAGO } = item

        if (PAR_RE_VALORPAGO) {
          number = parseFloat(PAR_RE_VALORPAGO).toFixed(2)
          number = parseFloat(PAR_RE_VALORPAGO)
          numbers.push(number)
        }

        return item
      })

      let sum = numbers.reduce((a, b) => a + b, 0)

      if (sum) return this.formatDots(sum)

      return ''
    }, // sumPaidVals()

    sumVals (arr, field) {
      if (!field) return 'R$ 0,00'

      let numbers = []
      let number = 0

      arr = arr.map(item => {
        if (item[field]) {
          number = parseFloat(item[field]).toFixed(2)
          number = parseFloat(item[field])

          if (field == 'VLR_CORRIGIDO_TOTAL') {
            if (!this.isPaid(item)) {
              numbers.push(number)

              return item
            }
          } else {
            numbers.push(number)
          }
        }

        return item
      })

      let sum = numbers.reduce((a, b) => a + b, 0)

      if (sum) return this.formatDots(sum)

      return 'R$ 0,00'
    }, // sumPaidVals()

    sumArray (arr = []) {
      if (!arr || !arr.length) return '0'

      arr = arr.map(item => {
        item = parseFloat(item).toFixed(2)
        item = parseFloat(item)

        return item
      })

      let sum = arr.reduce((a, b) => a + b, 0)

      if (sum) return this.formatDots(sum)

      return ''
    }, // sumArray()

    formatDots (num = 0) {
      if (typeof num === 'string') num = parseFloat(num)

      return num.toFixed(2).replace('.', ',')
    }, // formatDots()

    formatCurrency (num = 0.00) {
      if (typeof num === 'string') num = parseFloat(num)
      if (isNaN(num)) return 'R$ 0,00'

      num = num.toFixed(2).split('.')

      num[0] = 'R$ ' + num[0].split(/(?=(?:...)*$)/).join('.')
      return num.join(',')
    }, // formatCurrency()

    isExpired (obj) {
      if (obj.PAR_DT_VENCIMENTO && obj.PAR_ST_INDICA) {
        let label = obj.PAR_ST_INDICA
        let isExpired = this.isDatePast(obj) && label === 'ABERTA'

        if (isExpired) console.debug('VENCIDA!', obj)

        return isExpired
      }
    }, // isExpired()

    returnTextParcela (obj) {
      if (obj.PAR_ST_INDICA === 'BAIXADA') return 'Paga'

      if (this.isDatePast(obj)) {
        if (this.isExpired(obj)) return 'Vencida'
        else return 'Paga'
      }

      return 'Em aberto'
    }, // returnTextParcela()

    isPaid (obj) {
      return obj.PAR_ST_INDICA === 'BAIXADA'
    }, // isPaid()

    isDatePast (obj) {
      let vcto = new Date(obj.PAR_DT_VENCIMENTO)
      let isExpired = this.todayDate > vcto

      return isExpired
    }, // isDatePast()

    recarregar (item) {
      console.log('[recarregar] parcela:', item)
      this.load(false)
    },

    async toggleModalBars (obj) {
      console.log('[toggleModalBars] parcela:', obj)
      this.toggleModalInfo('Carregando...', '')

      try {
        let { contratoAtual } = this.$store.state
        let xhr = await PagesService.getBoleto(contratoAtual.codigo, obj.PAR_IN_CODIGO)

        this.optsModalInfo.render = false

        const dadosBoleto = xhr.dadosBoleto || xhr
        const arquivo = xhr.arquivo || {}
        const linhaDigitavel = dadosBoleto.LINHA_DIGITAVEL
        const base64 = arquivo.base64
        const erro = dadosBoleto.ERRO === true || arquivo.ERRO === true
        const errorMessage = dadosBoleto.message || arquivo.message

        if (erro || errorMessage) {
          this.toggleModalInfo('Erro', errorMessage || 'Falha ao gerar boleto. Tente novamente mais tarde.')
          return
        }

        if (base64) {
          this.openPDF(base64)
        }

        if (linhaDigitavel) {
          this.optsModalBoleto.linhaDigitavel = linhaDigitavel
          this.optsModalBoleto.render = true
        } else if (!base64) {
          this.toggleModalInfo('Erro', 'Resposta inesperada do servidor. Tente novamente mais tarde.')
        }
      } catch (e) {
        console.error('Falha ao recuperar boleto', e)
        this.optsModalInfo.render = false
        this.toggleModalInfo('Erro', 'Falha ao carregar boleto. Tente novamente mais tarde.')
      }
    }, // toggleModalBars()

    openPDF (base64 = '') {
      if (!base64) return

      let newBlob = this.convertBase64toBlob(base64, 'application/pdf')

      // IE
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob)
        // this.toggleModalAnt()
        return
      }

      // Cria elemento e simula clique
      const data = window.URL.createObjectURL(newBlob)

      let link = document.createElement('a')
      link.href = data
      link.download = 'file.pdf'

      if (typeof InstallTrigger !== 'undefined') { // se for FF
        let clickEvent = new MouseEvent('click', {
          view: window,
          bubbles: true,
          cancelable: false
        })

        link.dispatchEvent(clickEvent)
      } else {
        link.click()

        setTimeout(() => {
          window.URL.revokeObjectURL(data)
        }, 100)
      }
    }, // openPDF()

    convertBase64toBlob (content, contentType) {
      contentType = contentType || ''

      let sliceSize = 512
      let byteCharacters = window.atob(content) // Converte o base64 para o binário
      let byteArrays = []

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        let slice = byteCharacters.slice(offset, offset + sliceSize)
        let byteNumbers = new Array(slice.length)

        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }

        let byteArray = new Uint8Array(byteNumbers)
        byteArrays.push(byteArray)
      }

      let blob = new Blob(byteArrays, {
        type: contentType
      }) // Cria o Blob

      return blob
    }, // convertBase64toBlob()

    async simulaAntecipacao (item) {
      console.log('[simulaAntecipacao] parcela:', item)
      this.toggleModalInfo('Carregando...', '')

      try {
        let { contratoAtual } = this.$store.state
        let obj = { codigoContrato: contratoAtual.codigo, codigoParcela: item.PAR_IN_CODIGO }
        let xhr = await PagesService.simulaAntecipacao(obj)

        this.optsModalInfo.render = false

        if (xhr.VALOR_DESCONTO && xhr.VALOR_TOTAL) {
          let { VALOR_DESCONTO, VALOR_TOTAL, ERRO, DESCRICAO } = xhr

          if (ERRO) {
            this.optsModalAnt.typeStatus = 'FAIL'
            this.optsModalAnt.text = DESCRICAO || 'Ocorreu um erro'
            this.optsModalAnt.render = true
            return
          }

          this.optsModalAnt.typeStatus = 'INFO'
          this.optsModalAnt.info = {
            VALOR_DESCONTO: this.formatCurrency(VALOR_DESCONTO),
            VALOR_TOTAL: this.formatCurrency(VALOR_TOTAL),
            VALOR_ANTIGO: this.formatCurrency(item.PAR_RE_VALORATUALIZADO),
            VALOR_TOTAL_RAW: VALOR_TOTAL,
            VALOR_DESCONTO_RAW: VALOR_DESCONTO,
            ...obj
          }
        } else {
          this.optsModalAnt.typeStatus = 'FAIL'
        }

        // this.load()
      } catch (e) {
        this.optsModalAnt.typeStatus = 'FAIL'
        console.error('Falha ao simular antecipação', e)
      }

      this.toggleModalAnt()
    }, // simulaAntecipacao()

    async antecipaParcela (item) {
      console.log('[antecipaParcela] parcela:', item)
      this.toggleModalInfo('Carregando...', '')

      try {
        let xhr = await PagesService.getBoletoAntecipacao(item.codigoContrato, item.codigoParcela)

        // const xhr = {
        //   DESCRICAO: 'A solicitacao do registro do boleto(147202) da antecipação (20666) do contrato(16047) foi realizada com sucesso!'
        // }

        this.optsModalInfo.render = false

        // Check for error response
        if (xhr.message) {
          this.optsModalAnt.typeStatus = 'FAIL'
          this.optsModalAnt.text = xhr.message
          this.optsModalAnt.render = true
          return
        }

        // Success response with DESCRICAO
        if (xhr.DESCRICAO) {
          this.optsModalAnt.typeStatus = 'OK'
          this.optsModalAnt.text = xhr.DESCRICAO
          this.optsModalAnt.render = true
          this.load()
          return
        }

        // Fallback if neither field exists
        this.optsModalAnt.typeStatus = 'FAIL'
        this.optsModalAnt.text = 'Resposta inesperada do servidor'
        this.toggleModalAnt()
      } catch (e) {
        this.optsModalAnt.typeStatus = 'FAIL'
        this.optsModalAnt.text = 'Falha ao realizar antecipação. Tente mais tarde.'
        this.toggleModalAnt()
        console.error('Falha ao realizar antecipação', e)
      }
    }, // antecipaParcela()

    toggleModalInfo (title, str) {
      this.optsModalInfo.title = title
      this.optsModalInfo.text = str
      this.optsModalInfo.render = !this.optsModalInfo.render
    }, // toggleModalInfo()

    toggleModalAnt (item = null) {
      // this.optsModalAnt.typeStatus = item ? 'INFO' : 'INFO'
      this.optsModalAnt.render = !this.optsModalAnt.render
    }, // toggleModalAnt()

    canShowAntecipacao (item) {
      const tipo = (item.PAR_DS_PARCELA || '').toLowerCase()

      // Intermediária e Conclusão podem ser antecipadas sempre
      if (tipo === 'intermediária' || tipo === 'conclusão') {
        return true
      }

      // Demais tipos: só a parcela com maior vencimento (por tipo)
      if (!this.extrato.DadosParcela || !this.extrato.DadosParcela.cDadosParcela) {
        return true
      }

      const mesmoTipo = this.extrato.DadosParcela.cDadosParcela.filter(p => {
        return p.PAR_DS_PARCELA &&
               p.PAR_DS_PARCELA.toLowerCase() === tipo &&
               ['N', 'R', 'E'].includes(p.PAR_CH_STATUSENVIO) &&
               !this.isExpired(p) &&
               !this.isPaid(p)
      })

      if (mesmoTipo.length <= 1) {
        return true
      }

      const ultimaParcela = mesmoTipo.reduce((latest, current) => {
        const latestDate = new Date(latest.PAR_DT_VENCIMENTO)
        const currentDate = new Date(current.PAR_DT_VENCIMENTO)
        return currentDate > latestDate ? current : latest
      })

      return item.PAR_IN_CODIGO === ultimaParcela.PAR_IN_CODIGO
    }, // canShowAntecipacao()

    print () {
      window.print()
    } // print()
  }, // methods

  computed: {
    allowAntecipacao () {
      return true
    }
  } // computed
}
</script>

<style lang="sass" scoped>
  @import '@/assets/sass/_base.sass'

  .iframe
    padding: 15px 0 !important
    background-color: map-get($colors, gray) !important
    min-height: none !important
    margin-bottom: 25px

  h2
    font-size: 22px

  .user-data
    width: 100%
    display: flex
    justify-content: center
    color: #fff

    .-list
      flex: 0 0 calc(33.33% - 1px)
      padding: 5px 30px
      display: flex
      flex-direction: column
      align-items: center

      + .-list
        border-left: 1px solid #6c6c6c

      .wrapper-icon
        height: 88px

      ul

        li
          display: flex
          font-size: 15px

          .label
            width: 130px
            flex: 0 0 auto
            margin-right: 7px
            text-align: right

          .desc

            text-transform: uppercase
            // white-space: nowrap
            font-weight: 700

  .responsive
    width: auto

  .warning-month
    margin-top: 25px
    text-align: center
    font-size: 14px

  .btn-print
    text-align: right
    margin-bottom: 15px
    display: flex
    align-items: center
    justify-content: flex-end
    text-transform: uppercase

    i
      margin-right: 5px

  .table-finances
    +box-border
    display: table

    thead
      tr
        background-color: map-get($colors, gray)

        th
          +aligncenter
          text-transform: uppercase
          color: #fff
          text-align: center
          vertical-align: middle
          font-size: 13px
          font-weight: 700
          padding: 15px 6px

          &:nth-child(8)
            width: 120px

          .holder
            width: 100%
            display: flex
            align-items: center
            justify-content: center

            .icon
              flex: 0 0 22px
              margin-left: 5px
              transition: all .2s linear

              &:hover
                cursor: pointer
                transform: scale(1.1)

    tbody
      tr
        // border-bottom: 1px solid #dddddd

        &:last-of-type
          border-bottom: none

        td
          +aligncenter
          padding: 10px 2.5px
          vertical-align: middle
          text-transform: uppercase
          font-size: 13px
          white-space: nowrap

          &:first-child
            text-align: left
            max-width: 140px
            padding-left: 35px

          &:nth-of-type(8)
            min-width: 120px
            max-width: 120px
            white-space: nowrap

          &:nth-of-type(9)
            text-align: center

            button
              display: inline-flex

          &:nth-of-type(10)
            max-width: 155px

          > button
            padding: 5px 10px 3px
            font-size: 13px
            font-weight: 400
            letter-spacing: 0
            background-color: transparent

            &.processing
              // pointer-events: none
              background: none
              color: #232323
              padding: 0
              white-space: nowrap

            &.-simulate
              width: 100%
              display: flex
              align-items: center
              justify-content: center
              height: 33px
              padding: 0 10px
              font-size: 10px
              line-height: 1.2
              font-weight: 700
              text-transform: none
              background-color: map-get($colors, blue)
              transition: all .3s ease

              &:hover
                background-color: darken(map-get($colors, blue), 10)

          a.refresh-button
            pointer-events: all
            padding-left: 20px
            margin: 0 auto
            display: flex
            align-items: center
            justify-content: center
            background:
              image: url(~/images/refresh-button.png)
              repeat: no-repeat
              position: center left
              size: contain

          .buttons
            width: 100%
            display: flex
            justify-content: center

            > button
              width: 44px
              height: 44px
              padding: 0
              background-color: transparent
              border: 1px solid #000

              &:first-child
                margin-right: 5px

              &:hover
                transform: scale(0.95)

          .badge
            width: 100%
            height: 33px
            display: flex
            justify-content: center
            align-items: center
            font-size: 13px
            padding: 0 7px
            line-height: 1
            white-space: nowrap
            font-weight: 700
            color: #fff
            text-transform: none
            background-color: #9d9d9d
            @extend %no-select

            &.-success
              background-color: map-get($colors, green)

            &.-warning
              background-color: map-get($colors, yellow)

            &.-danger
              background-color: map-get($colors, red)

  @media (max-width: 767px)
    .user-data
      justify-content: flex-start
      flex-direction: column
      padding: 5px 10px

      .-list
        flex: 0 0 100%
        padding: 10px 5px
        display: flex
        flex-direction: row
        align-items: center
        border-bottom: 1px solid #6b6b6b

        + .-list
          border-left: none

        .wrapper-icon
          margin-right: 10px;
          height: auto

        ul

          li
            display: block
            font-size: 12px

            .label
              width: auto
              flex: 0 0 auto
              margin-right: 7px
              text-align: right

            .desc
              text-transform: uppercase
              font-weight: 700

    table
      width: 100%
      overflow: visible
      border: none

      thead th .holder
        white-space: nowrap

  @media print
    @page { size: landscape; margin: 1.5cm; }

    .container
      padding: 0

    h1
      font-family: Verdana, sans-serif

    .btn-print
      display: none

    .user-data
      margin-bottom: 15px
      width: 100%
      display: block
      font-family: Verdana, sans-serif

      .-list

        ul
          li
            font-size: 12px
            height: 1cm;
            align-items: center;

      .-first
        ul
          li
            .label
              width: 260px !important

    table
      width: 100%
      left: initial
      transform: translateX(0)
      display: block
      font-family: Verdana, sans-serif
      page-break-before: always !important;
      // page-break-inside: avoid !important;

      thead,
      tbody
        tr
          td,
          th
            padding: 7px
            font-size: 10.5px
            font-family: Verdana, sans-serif !important

            span
              font-size: 10.5px !important

            &:first-of-type
              padding: 7px
              font-size: 10.5px

            &:nth-of-type(10)
              display: none

      thead
        th .holder .icon
          display: none

      tbody
        tr
          td
            white-space: nowrap
</style>
